import { Pipe, PipeTransform } from '@angular/core';
import { LayoutService } from '@app/layout/layout.service';

@Pipe({
  name: 'jsonStr'
})
export class JsonStrPipe implements PipeTransform {
  constructor(private layoutService: LayoutService) {}

  transform(value: string): string {
    if (value == null || value === 'null') {
      return '';
    }

    let returnedVal = '';

    let obj = JSON.parse(value);
    let keys = Object.keys(obj[0]);

    obj.forEach(element => {
      keys.forEach(key => {
        returnedVal += key + " :" + element[key] + ' ,';
      });
      returnedVal += '\n';
    });

    return returnedVal;
  }

}
